export const options = {
    more: <{ [name: string]: string | undefined }>{
        "A": "Ala",
        "R": "Arg",
        "N": "Asn",
        "D": "Asp",
        "C": "Cys",
        "Q": "Gln",
        "E": "Glu",
        "G": "Gly",
        "H": "His",
        "I": "Ile",
        "L": "Leu",
        "K": "Lys",
        "M": "Met",
        "F": "Phe",
        "P": "Pro",
        "S": "Ser",
        "T": "Thr",
        "W": "Trp",
        "Y": "Tyr",
        "*": "TER",
        "V": "Val",
    },

    single: <{ [name: string]: string | undefined }>{
        ALA: "A",
        ARG: "R",
        ASN: "N",
        ASP: "D",
        CYS: "C",
        GLN: "Q",
        GLU: "E",
        GLY: "G",
        HIS: "H",
        ILE: "I",
        LEU: "L",
        LYS: "K",
        MET: "M",
        PHE: "F",
        PRO: "P",
        SER: "S",
        THR: "T",
        TRP: "W",
        TYR: "Y",
        TER: "*",
        VAL: "V",
    },
};
